var map = {
	"./dsp/Commodity": 627,
	"./dsp/Commodity.jsx": 627,
	"./dsp/LocationSuggestions": 628,
	"./dsp/LocationSuggestions.jsx": 628,
	"./imaging/TableImagingList": 429,
	"./imaging/TableImagingList.jsx": 429
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 921;